import React from 'react';
import AdviserInfo from './steps/landing/AdviserInfo';
import HowItWorks from './steps/landing/HowItWorks';
import VerifiedDetails from './steps/landing/VerifiedDetails';
import AboutUs from './steps/shared/AboutUs';
import AsFeaturedIn from './steps/shared/AsFeaturedIn';
import ContentSection from './steps/landing/ContentSection';

const LandingPage = () => {
    const scrollToForm = () => {
        const formAnchor = document.getElementById('form-anchor');
        formAnchor.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="landing-page push-down-30">
            <ContentSection />
            <HowItWorks />
            <VerifiedDetails />
            <AdviserInfo scrollToForm={scrollToForm} />
            <AsFeaturedIn />
            <AboutUs />
        </div>
    );
};

export default LandingPage;
